import {
  Box,
  Flex,
  Heading,
  Text,
  Link,
  Icon,
  SimpleGrid,
} from "@chakra-ui/react";
import { FaLinkedin, FaGithub, FaEnvelope } from "react-icons/fa"; // Import other icons as needed

import GitHubCalendar from "react-github-calendar";
const Contact = () => {
  return (
    <Box mt="5%">
      <Heading as="h2" size="xl">
        GitHub statistics
      </Heading>

      <SimpleGrid
        columns={{ base: 1, md: 2 }}
        spacing={10}
        className="react-activity-calendar"
        align="center"
        p={10}
      >
        {/* Top Languages Card */}
        <Box w="80%" m="auto">
          <img
            id="github-top-langs"
            src="https://github-readme-stats.vercel.app/api/top-langs?username=kkalyankumar9&layout=compact&exclude_repo=Lybrate-Website-Clone-Version-2.0,Lybrate-Website-Clone,Adidas-Clone&hide=shell&border_radius=0&theme=dark"
            alt="Top Languages by kkalyankumar9"
            width="100%"
          />
        </Box>

        {/* GitHub Stats Card */}
        <Box w="80%" m="auto">
          <img
            id="github-stats-card"
            src="https://github-readme-stats.vercel.app/api?username=kkalyankumar9&show_icons=true&include_all_commits=true&count_private=true&hide=issues,contribs&border_radius=0&locale=en&theme=dark"
            alt="GitHub Stats by kkalyankumar9"
            width="100%"
          />
        </Box>

        {/* Placeholder Box for Future Content */}
        <Box w="80%" m="auto">
          {/* Add any additional content here */}
        </Box>
      </SimpleGrid>

      {/* GitHub Contributions Calendar */}
      <Box
        w="100% "
        display={"flex"}
        justifyContent={"center"}
        alignItems={"center"}
      >
        <GitHubCalendar
          username="kkalyankumar9"
          className="react-activity-calendar"
          style={{ fontSize: "20px" }}
        />
      </Box>

      <Box id="contact" py={10} textAlign="center">
        <Heading as="h2" size="xl" className="heading">
          Contact <span>Me</span>
        </Heading>
        <Flex className="contact_me" direction="column" align="center" mt={4}>
          <Text id="contact-phone" mb={2}>
            Contact Number: +91 8886081842
          </Text>
          <Link id="contact-email" href="mailto:kkalyan2312@gmail.com">
            Email Address: kkalyan2312@gmail.com
          </Link>
          <Text mt={2}>Address: Adoni, Andhra Pradesh-518301</Text>
          <Flex mt={4} justify="center">
            <Link
              className="project-link linkdk"
              id="contact-linkedin"
              target="_blank"
              href="https://www.linkedin.com/in/k-kalyan-kumar-a44321163/"
              mr={4}
              _hover={{ bgColor: "teal" }}
            >
              <Icon as={FaLinkedin} boxSize={8} color="teal.500" />
            </Link>
            <Link
              className="project-link linkd"
              id="contact-github"
              target="_blank"
              href="https://github.com/kkalyankumar9"
              mr={4}
              _hover={{ bgColor: "teal" }}
            >
              <Icon as={FaGithub} boxSize={8} color="teal.500" />
            </Link>
            <Link
              className="project-link linkd"
              href="mailto:kkalyan2312@gmail.com"
              target="_blank"
              _hover={{ bgColor: "teal" }}
            >
              <Icon as={FaEnvelope} boxSize={8} color="teal.500" />
            </Link>
          </Flex>
        </Flex>
      </Box>
    </Box>
  );
};

export default Contact;
